import { useLang } from "@/i18n/LanguageContext";
import { Store, CreditCard, Sparkles, Leaf } from "lucide-react";

const icons = [Store, CreditCard, Sparkles, Leaf];
const toneClasses: Record<string, string> = {
  mint: "bg-mint text-mint-foreground",
  coral: "bg-coral text-coral-foreground",
  butter: "bg-butter text-butter-foreground",
  lavender: "bg-lavender text-lavender-foreground",
};

const ValuePillars = () => {
  const { t } = useLang();
  return (
    <section id="platform" className="py-24 md:py-32 bg-background">
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-glow">01 · Platform</span>
          </div>
          <div className="lg:col-span-7">
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.pillars.title}</h2>
            <p className="mt-5 text-lg md:text-xl text-muted-foreground">{t.pillars.subtitle}</p>
          </div>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.pillars.items.map((item, i) => {
            const Icon = icons[i] || Store;
            return (
              <div
                key={item.title}
                className={`group relative rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1 ${toneClasses[item.tone]}`}
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-background/60 backdrop-blur">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-6 text-xl md:text-2xl font-extrabold leading-tight">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed opacity-80">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuePillars;
